import {Component, Input} from '@angular/core';

import {RegressionOutput} from 'shared/dtos/cockpit-kontrolle/einfluss-von-extremwerten-m1';

@Component({
  selector: 'app-regression-output',
  templateUrl: './regression-output.component.html',
  styleUrls: [
    './regression-output.component.scss',
    '../../../../cockpit-shared/contents/cockpit-styles.scss'
  ],
  standalone: false
})
export class RegressionOutputComponent {
  @Input() data: RegressionOutput;
  columns: string[] = [
    'ohneResiduen05',
    'ohneResiduen025',
    'ohneResiduen5Prozent',
    'ohneResiduen10Prozent',
    'standardAnalyseModell'
  ];
}
